<!-- 地图 -->
<template>
  <div class="map-container" :id="'container' + itemId"></div>
</template>

<script>
import AMap from "AMap";
export default {
  props: {
    itemId: { type: String, default: "" },
  },
  // 地理编码包含正向地理编码和逆向地理编码两种：
  // 正向地理编码： 将地址描述信息转换成地理坐标（经纬度），对应为AMap.Geocoder的getLocation方法
  // 逆向地理编码：将地理坐标（经纬度）转换成地址描述信息，对应为AMap.Geocoder的getAddress方法
  methods: {
    markLocation(mapId, address) {
      var map = new AMap.Map(`container${this.itemId}`, {
        zoom: 16, //级别
        center: [address.longitude, address.latitude], //中心点坐标
        // viewMode:'3D'//使用3D视图
      });

      var infoWindow = new AMap.InfoWindow({
        //创建信息窗体
        isCustom: true, //使用自定义窗体
        content:
          '<div style="background-color: #fff;padding: 30px;border: 1px solid #e1e1e1;">' +
          address.companyName +
          "</div>", //信息窗体的内容可以是任意html片段
        offset: new AMap.Pixel(16, -45),
      });
      var onMarkerClick = function (e) {
        infoWindow.open(map, e.target.getPosition()); //打开信息窗体
        //e.target就是被点击的Marker
      };
      var marker = new AMap.Marker({
        position: new AMap.LngLat(address.longitude, address.latitude),
      });
      map.add(marker);
      marker.on("click", onMarkerClick);
    },
  },
};
</script>
<style>
.map-container {
  width: 100%;
  height: 300px;
}
</style>
